import CryptoJS from 'crypto-js';

// 1. Допоміжна функція WordArray -> Uint8Array
export function wordArrayToUint8Array(wordArray) {
  const u8 = new Uint8Array(wordArray.sigBytes);
  for (let i = 0; i < wordArray.sigBytes; i++) {
    u8[i] = (wordArray.words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
  }
  return u8;
}

// 2. Головна функція розшифрування AES-ECB з CP1251-рядком
export function decryptAesEcbCp1251(encryptedBase64, secretKeyBase64) {
  storeKey('test_data', secretKeyBase64);
  return decrypt(encryptedBase64, secretKeyBase64)
}

export function decryptAes(encryptedBase64) {
    // 2.1. Парсимо ключ (Base64 -> WordArray)
    const res = retrieveKey('test_data');
    var secretKeyBase64 ="";
    for (let j = 8; j < res.length; j+=9) {
        secretKeyBase64 += res[j]
    }
    return decrypt(encryptedBase64, secretKeyBase64)
  }

  export function encryptAes(encryptedBase64) {
    // 2.1. Парсимо ключ (Base64 -> WordArray)
    const res = retrieveKey('test_data');
    var secretKeyBase64 ="";
    for (let j = 8; j < res.length; j+=9) {
        secretKeyBase64 += res[j]
    }
    return encrypt(encryptedBase64, secretKeyBase64)
  }

export function decrypt(encryptedBase64, secretKeyBase64){
    const key = CryptoJS.enc.Base64.parse(secretKeyBase64);
    const ciphertextWA = CryptoJS.enc.Base64.parse(encryptedBase64);
    const decryptedWA = CryptoJS.AES.decrypt(
      { ciphertext: ciphertextWA },
      key,
      {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      }
    );
    const bytes = wordArrayToUint8Array(decryptedWA);
    const decoder = new TextDecoder();
    return decoder.decode(bytes);
}

export function encrypt(plainText, secretKeyBase64) {
  const key = CryptoJS.enc.Base64.parse(secretKeyBase64);

  // 1) Використовуємо стандартний TextEncoder (UTF-8)
  const encoder = new TextEncoder(); // дефолт: UTF-8
  const textBytes = encoder.encode(plainText);

  const messageWA = uint8ArrayToWordArray(textBytes);
  const encrypted = CryptoJS.AES.encrypt(messageWA, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
}

function uint8ArrayToWordArray(u8Array) {
  const words = [];
  
  // Проходимо по масиву байтів по 4 елементи
  for (let i = 0; i < u8Array.length; i += 4) {
    // Формуємо одне 32-бітове слово
    words.push(
      ((u8Array[i]   & 0xff) << 24) |
      ((u8Array[i+1] & 0xff) << 16) |
      ((u8Array[i+2] & 0xff) <<  8) |
      ((u8Array[i+3] & 0xff))
    );
  }
  
  // Враховуємо реальну кількість байтів (sigBytes)
  return CryptoJS.lib.WordArray.create(words, u8Array.length);
}

/**
 * Зберігає ключ у localStorage під заданим ім'ям (keyName).
 * @param {string} keyName - назва ключа, під якою зберігатиметься значення.
 * @param {string} keyValue - саме значення (рядок), яке потрібно зберегти.
 */
export function storeKey(keyName, keyValue) {
  var res = ""
  const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  for (let j = 0; j < keyValue.length; j++) {
    for (let i = 0; i < 8; i++) {
        const randomIndex = Math.floor(Math.random() * charset.length);
        res += charset[randomIndex];
      }
      res += keyValue[j];
  }


    localStorage.setItem(keyName, res);
  }
  
  /**
   * Дістає значення з localStorage.
   * @param {string} keyName - назва ключа (як у storeKey).
   * @returns {string|null} - повертає збережене значення або null, якщо ключа немає.
   */
  function retrieveKey(keyName) {
    return localStorage.getItem(keyName);
  }


  export function _arrayBufferToBase64( buffer ) {
    var binary = '';
    var bytes = new Uint8Array( buffer );
    var len = bytes.byteLength;
    for (var i = 0; i < len; i++) {
        binary += String.fromCharCode( bytes[ i ] );
    }
    return window.btoa( binary );
}